import { createSlice } from '@reduxjs/toolkit';

interface EditAdminProfileState {
  isEditing: boolean;
}

const initialState: EditAdminProfileState = {
  isEditing: false,
};

const editAdminProfile = createSlice({
  name: 'edit-admin-profile',
  initialState,
  reducers: {
    activeEditModeAdmin(state) {
      state.isEditing = true;
    },
    disableEditModeAdmin(state) {
      state.isEditing = false;
    },
  },
});

export const { activeEditModeAdmin, disableEditModeAdmin } =
  editAdminProfile.actions;

export default editAdminProfile.reducer;
